import {
    useEffect,
    useState,
} from 'react';
import api from "../../../api/api";
import {IMAGE_URL} from "../../../path";
import BodyEditor from './BodyEditor'

type Props = {

    blog?: any;

    onClose: () => void;

    onSave: (
        data: FormData
    ) => void;

};

type BlogComponent = {

    id?: number;

    component_type:
        | 'heading'
        | 'body'
        | 'image'
        | 'two_images';

    display_order: number;

    component: any;

};

export default function BlogEditorModal({

                                            blog,

                                            onClose,

                                            onSave,

                                        }: Props)
{
    const [
        title,
        setTitle,
    ] = useState('');

    const [
        subtitle,
        setSubtitle,
    ] = useState('');

    const [
        categories,
        setCategories,
    ] = useState<any[]>([]);

    const [
        category,
        setCategory,
    ] = useState<number | null>(
        null
    );

    const [
        publishDate,
        setPublishDate,
    ] = useState('');

    const [
        showAddMenu,
        setShowAddMenu,
    ] = useState(false);

    const [draft, setDraft] =
        useState(false);

    const [active, setActive] =
        useState(true);

    console.log(blog);
    const [
        coverImage,
        setCoverImage,
    ] = useState<File | null>(
        null
    );

    const [
        components,
        setComponents,
    ] = useState<BlogComponent[]>([]);

    const [
        coverPreview,
        setCoverPreview,
    ] = useState(
        blog?.cover_image || ''
    );

    useEffect(() => {

        loadOptions();

    }, []);

    const getImageUrl = (
        path?: string
    ) => {

        if (!path) {

            return '';

        }

        if (

            path.startsWith(
                'http'
            ) ||

            path.startsWith(
                'blob:'
            )

        ) {

            return path;

        }

        return `${IMAGE_URL}${path}`;

    };

    const removeComponent = (
        index: number
    ) =>
    {
        const updated =
            [...components];

        updated.splice(
            index,
            1
        );

        updated.forEach(
            (
                component,
                i
            ) => {

                component.display_order =
                    i + 1;

            }
        );

        setComponents(
            updated
        );
    };

    const moveUp = (
        index: number
    ) =>
    {
        if (
            index === 0
        )
        {
            return;
        }

        const updated =
            [...components];

        [

            updated[index],

            updated[index - 1],

        ] = [

            updated[index - 1],

            updated[index],

        ];

        updated.forEach(
            (
                component,
                i
            ) => {

                component.display_order =
                    i + 1;

            }
        );

        setComponents(
            updated
        );
    };

    const moveDown = (
        index: number
    ) =>
    {
        if (
            index ===
            components.length - 1
        )
        {
            return;
        }

        const updated =
            [...components];

        [

            updated[index],

            updated[index + 1],

        ] = [

            updated[index + 1],

            updated[index],

        ];

        updated.forEach(
            (
                component,
                i
            ) => {

                component.display_order =
                    i + 1;

            }
        );

        setComponents(
            updated
        );
    };

    const loadOptions = async () =>
    {
        const response =
            await api.get(
                '/blog-options'
            );

        setCategories(
            response.data.categories
        );
    };

    useEffect(() => {

        if (
            !blog
        )
        {
            return;
        }

        setTitle(
            blog.title
        );

        setSubtitle(
            blog.subtitle
        );

        setCategory(
            blog.blog_category_id
        );

        setCoverPreview(
            blog.cover_image ?? ''
        );

        setPublishDate(
            blog.published_at
                ? blog.published_at.slice(0, 10)
                : ''
        );

        setDraft(
            blog.draft
        );

        setActive(
            blog.is_active
        );

        if (
            blog.components
        ) {

            setComponents(
                blog.components
            );

        }

    }, [
        blog
    ]);

    const addComponent = (
        type:
        BlogComponent['component_type']
    ) =>
    {
        const component =
            {
                component_type:
                type,

                display_order:
                    components.length + 1,

                component:
                    {},
            };

        switch (
            type
            )
        {
            case 'heading':

                component.component = {

                    heading: '',

                };

                break;

            case 'body':

                component.component = {

                    body: '',

                };

                break;

            case 'image':

                component.component = {

                    image: null,

                    image_path: '',

                    preview: '',

                };

                break;

            case 'two_images':

                component.component = {

                    image_1: null,

                    image_2: null,

                    image_path_1: '',

                    image_path_2: '',

                    preview_1: '',

                    preview_2: '',

                };

                break;
        }

        setComponents([

            ...components,

            component,

        ]);

        setShowAddMenu(
            false
        );
    };

    const renderTwoImages = (
        component: BlogComponent,
        index: number
    ) => (

        <div
            key={
                component.id ??
                index
            }
            className="blog-component-card"
        >

            <label>

                Image 1

            </label>

            {(

                component.component.preview_1 ||

                component.component.image_path_1

            ) && (

                <img

                    src={
                        getImageUrl(

                            component.component.preview_1 ||

                            component.component.image_path_1

                        )
                    }

                    alt=""

                    className="image-preview"

                />

            )}

            <p className="field-hint">

                Maximum file size: 2MB

            </p>

            <input

                type="file"

                accept="image/*"

                onChange={(e) => {

                    const file =
                        e.target.files?.[0];

                    if (!file) {

                        return;

                    }

                    if (
                        file.size >
                        2 * 1024 * 1024
                    ) {

                        alert(
                            'Image must be 2MB or smaller.'
                        );

                        return;

                    }

                    updateComponent(
                        index,
                        {

                            image_1: file,

                            preview_1:
                                URL.createObjectURL(
                                    file
                                ),

                        }
                    );

                }}

            />

            <label>

                Image 2

            </label>

            {(

                component.component.preview_2 ||

                component.component.image_path_2

            ) && (

                <img

                    src={
                        getImageUrl(

                            component.component.preview_2 ||

                            component.component.image_path_2

                        )
                    }

                    alt=""

                    className="image-preview"

                />

            )}

            <p className="field-hint">

                Maximum file size: 2MB

            </p>

            <input

                type="file"

                accept="image/*"

                onChange={(e) => {

                    const file =
                        e.target.files?.[0];

                    if (!file) {

                        return;

                    }

                    if (
                        file.size >
                        2 * 1024 * 1024
                    ) {

                        alert(
                            'Image must be 2MB or smaller.'
                        );

                        return;

                    }

                    updateComponent(
                        index,
                        {

                            image_2: file,

                            preview_2:
                                URL.createObjectURL(
                                    file
                                ),

                        }
                    );

                }}

            />

            {renderComponentActions(
                index
            )}

        </div>

    );

    const renderImage = (
        component: BlogComponent,
        index: number
    ) => (

        <div
            key={
                component.id ??
                index
            }
            className="blog-component-card"
        >

            <label>

                Image

            </label>

            {
                (
                    component.component.preview ||
                    component.component.image_path
                ) && (

                    <img
                        src={
                            getImageUrl(
                                component.component.preview ||
                                component.component.image_path
                            )
                        }
                        alt=""
                        className="image-preview"
                    />

                )
            }

            <p className="field-hint">

                Maximum file size: 2MB

            </p>

            <input

                type="file"

                accept="image/*"

                onChange={(e) => {

                    const file =
                        e.target.files?.[0];

                    if (!file) {

                        return;

                    }

                    if (
                        file.size >
                        2 * 1024 * 1024
                    ) {

                        alert(
                            'Image must be 2MB or smaller.'
                        );

                        return;

                    }

                    updateComponent(
                        index,
                        {

                            image: file,

                            preview:
                                URL.createObjectURL(
                                    file
                                ),

                        }
                    );

                }}

            />

            {renderComponentActions(
                index
            )}

        </div>

    );

    const renderBody = (
        component: BlogComponent,
        index: number
    ) =>
        (
            <div
                key={
                    component.id ??
                    index
                }
                className="blog-component-card"
            >

                <label>

                    Body

                </label>

                <BodyEditor

                    value={
                        component.component.body ?? ''
                    }

                    onChange={(value: any) =>
                        updateComponent(
                            index,
                            {

                                body:
                                value,

                            }
                        )
                    }

                />

                {renderComponentActions(
                    index
                )}

            </div>
        );

    const renderHeading = (
        component: BlogComponent,
        index: number
    ) =>
        (
            <div
                key={
                    component.id ??
                    index
                }
                className="blog-component-card"
            >

                <label>

                    Heading

                </label>

                <input

                    type="text"

                    value={
                        component.component.heading ?? ''
                    }

                    onChange={(e) =>
                        updateComponent(
                            index,
                            {
                                heading:
                                e.target.value,
                            }
                        )
                    }

                />

                {renderComponentActions(
                    index
                )}

            </div>
        );

    const renderComponentActions = (
        index: number
    ) => (

        <div className="component-actions">

            <button

                type="button"

                className="move-btn"

                disabled={
                    index === 0
                }

                onClick={() =>
                    moveUp(
                        index
                    )
                }

            >

                ↑

            </button>

            <button

                type="button"

                className="move-btn"

                disabled={
                    index ===
                    components.length - 1
                }

                onClick={() =>
                    moveDown(
                        index
                    )
                }

            >

                ↓

            </button>

            <button

                type="button"

                className="delete-btn"

                onClick={() =>
                    removeComponent(
                        index
                    )
                }

            >

                Delete

            </button>

        </div>

    );

    const updateComponent = (
        index: number,
        updates: Record<string, any>
    ) =>
    {
        const updated =
            [...components];

        updated[index] = {

            ...updated[index],

            component: {

                ...updated[index].component,

                ...updates,

            },

        };

        setComponents(
            updated
        );
    };

    const handleSubmit = (
        e: React.FormEvent
    ) => {

        e.preventDefault();

        const formData =
            new FormData();

        formData.append(
            'title',
            title
        );

        formData.append(
            'subtitle',
            subtitle
        );

        formData.append(
            'blog_category_id',
            String(category)
        );

        formData.append(
            'published_at',
            publishDate
        );

        formData.append(
            'draft',
            draft
                ? '1'
                : '0'
        );

        formData.append(
            'is_active',
            active
                ? '1'
                : '0'
        );

        if (
            coverImage
        ) {

            formData.append(
                'cover_image',
                coverImage
            );

        }

        components.forEach(
            (
                component,
                index
            ) => {

                formData.append(
                    `components[${index}][component_type]`,
                    component.component_type
                );

                formData.append(
                    `components[${index}][display_order]`,
                    String(
                        component.display_order
                    )
                );

                if (component.id) {

                    formData.append(
                        `components[${index}][id]`,
                        String(component.id)
                    );

                }

                switch (
                    component.component_type
                    ) {

                    case 'heading':

                        formData.append(
                            `components[${index}][heading]`,
                            component.component.heading
                        );

                        break;

                    case 'body':

                        formData.append(
                            `components[${index}][body]`,
                            component.component.body
                        );

                        break;

                    case 'image':

                        if (
                            component.component.image
                        ) {

                            formData.append(
                                `components[${index}][image]`,
                                component.component.image
                            );

                        }

                        break;

                    case 'two_images':

                        if (
                            component.component.image_1
                        ) {

                            formData.append(
                                `components[${index}][image_1]`,
                                component.component.image_1
                            );

                        }

                        if (
                            component.component.image_2
                        ) {

                            formData.append(
                                `components[${index}][image_2]`,
                                component.component.image_2
                            );

                        }

                        break;

                }

            }
        );

        onSave(formData);

    };

    return (

        <div
            className="modal-overlay"
            onClick={onClose}
        >

            <div
                className="modal-box"
                onClick={(e) =>
                    e.stopPropagation()
                }
            >

                <h2>

                    {

                        blog

                            ?

                            'Edit Blog'

                            :

                            'Add Blog'

                    }

                </h2>

                <form
                    className="modal-form"
                    onSubmit={
                        handleSubmit
                    }
                >

                    <label>

                        Title

                    </label>

                    <input

                        type="text"

                        value={title}

                        onChange={(e) =>
                            setTitle(
                                e.target.value
                            )
                        }

                        required

                    />

                    <label>

                        Subtitle

                    </label>

                    <input

                        type="text"

                        value={subtitle}

                        onChange={(e) =>
                            setSubtitle(
                                e.target.value
                            )
                        }

                    />

                    <label>

                        Category

                    </label>

                    <select

                        value={
                            category ?? ''
                        }

                        onChange={(e) =>
                            setCategory(
                                Number(
                                    e.target.value
                                )
                            )
                        }

                        required

                    >

                        <option value="">

                            Select Category

                        </option>

                        {

                            categories.map(
                                (category) => (

                                    <option

                                        key={
                                            category.id
                                        }

                                        value={
                                            category.id
                                        }

                                    >

                                        {

                                            category.name

                                        }

                                    </option>

                                )
                            )

                        }

                    </select>

                    <label>

                        Publish Date

                    </label>

                    <input

                        type="date"

                        value={publishDate}

                        onChange={(e) =>
                            setPublishDate(
                                e.target.value
                            )
                        }

                    />

                    <label>

                        Cover Image

                    </label>

                    {

                        coverPreview && (

                            <img

                                src={
                                    getImageUrl(
                                        coverPreview
                                    )
                                }

                                alt=""

                                className="image-preview"

                            />

                        )

                    }

                    <p className="field-hint">

                        Maximum file size: 2MB

                    </p>

                    <input

                        type="file"

                        accept="image/*"

                        onChange={(e) => {

                            const file =
                                e.target.files?.[0];

                            if (!file) {

                                return;

                            }

                            if (
                                file.size >
                                2 * 1024 * 1024
                            ) {

                                alert(
                                    'Image must be 2MB or smaller.'
                                );

                                return;

                            }

                            setCoverImage(
                                file
                            );

                            setCoverPreview(
                                URL.createObjectURL(
                                    file
                                )
                            );

                        }}

                    />

                    <label>

                        Draft

                    </label>

                    <select

                        value={
                            draft
                                ? '1'
                                : '0'
                        }

                        onChange={(e) =>
                            setDraft(
                                e.target.value === '1'
                            )
                        }

                    >

                        <option value="0">

                            No

                        </option>

                        <option value="1">

                            Yes

                        </option>

                    </select>

                    <label>

                        Active

                    </label>

                    <select

                        value={
                            active
                                ? '1'
                                : '0'
                        }

                        onChange={(e) =>
                            setActive(
                                e.target.value === '1'
                            )
                        }

                    >

                        <option value="1">

                            Yes

                        </option>

                        <option value="0">

                            No

                        </option>

                    </select>

                    <hr />

                    <h3>

                        Components

                    </h3>

                    {/* Components go here */}





                    {

                        components.map(

                            (
                                component,
                                index
                            ) => {

                                switch (
                                    component.component_type
                                    )
                                {
                                    case 'heading':

                                        return renderHeading(
                                            component,
                                            index
                                        );

                                    case 'body':

                                        return renderBody(
                                            component,
                                            index
                                        );

                                    case 'image':

                                        return renderImage(
                                            component,
                                            index
                                        );

                                    case 'two_images':

                                        return renderTwoImages(
                                            component,
                                            index
                                        );

                                    default:

                                        return null;
                                }

                            }

                        )

                    }

                    {

                        showAddMenu && (

                            <div className="component-menu">

                                <button
                                    type="button"
                                    className="action-btn"
                                    onClick={() =>
                                        addComponent(
                                            'heading'
                                        )
                                    }
                                >
                                    Heading
                                </button>

                                <button
                                    type="button"
                                    className="action-btn"
                                    onClick={() =>
                                        addComponent(
                                            'body'
                                        )
                                    }
                                >
                                    Body
                                </button>

                                <button
                                    type="button"
                                    className="action-btn"
                                    onClick={() =>
                                        addComponent(
                                            'image'
                                        )
                                    }
                                >
                                    Image
                                </button>

                                <button
                                    type="button"
                                    className="action-btn"
                                    onClick={() =>
                                        addComponent(
                                            'two_images'
                                        )
                                    }
                                >
                                    Two Images
                                </button>

                            </div>

                        )

                    }

                    <button

                        type="button"

                        className="action-btn"

                        onClick={() =>
                            setShowAddMenu(
                                !showAddMenu
                            )
                        }

                    >

                        Add Component

                    </button>

                    <div className="modal-actions">

                        <div className="left-actions">

                            <button

                                type="button"

                                className="cancel-btn"

                                onClick={
                                    onClose
                                }

                            >

                                Cancel

                            </button>

                        </div>

                        <div className="right-actions">

                            <button

                                type="submit"

                                className="action-btn"

                            >

                                Save

                            </button>

                        </div>

                    </div>

                </form>

            </div>

        </div>

    );
}
